<h2>{{message}}</h2>
<div class="rating">
  <span><strong>{{ value }}</strong></span>
</div>